























































































































































/** @format */

import { Component, Vue, Mixins, Watch } from 'vue-property-decorator';
// @ts-ignore hack
import TableMixin from '@root/common/mixins/table';
// @ts-ignore hack
import TableWidthMixin from '@root/common/mixins/table-width';
import ParkingLotSearch from '../../../components/parking-lot-search/index.vue';
import moment, { months } from 'moment';
import * as api from '../../../api/statistic-analysis';
// @ts-ignore hack
import EchartOption from '@root/common/const/e-chart-options';
import _ from 'lodash';
@Component({
  name: 'PaymentType',
  components: {
    ParkingLotSearch
  }
})
export default class PaymentType extends Mixins(TableMixin, TableWidthMixin) {
  private moment = moment;
  private isShowEtc = true;
  // 统计颗粒度
  dimensions: string = '0';
  // 快捷时间范围按钮
  timeQuickSelect: any = {
    '0': [{ value: 1, text: '近7天' }, { value: 2, text: '近1月' }]
  };

  timeQuickButtons: any[] = this.timeQuickSelect['0'];

  // 选择的时间范围
  timeRangeType: null | number = 1;

  // 自定义时间
  customTime: any[] = [];

  onCustomTimeChange(date: any, dateString: any) {
    if (date.length === 0) {
      // 重新设置快捷按钮
      this.timeRangeType = 1;
      this.onTimeRangeTypeChange();
    } else {
      // 自定义，清空快捷按钮
      const [startTime, endTime] = date;
      this.timeRangeType = null;
      const sTime = startTime.startOf('day').format('YYYY-MM-DD HH:mm:ss');
      const eTime = endTime.endOf('day').format('YYYY-MM-DD HH:mm:ss');
      const diff = moment(eTime).valueOf() - moment(sTime).valueOf();
      //计算出相差天数
      var days = Math.floor(diff / (24 * 3600 * 1000));
      if (days > 365) {
        this.customTime = [];
        return this.$message.error('最多选择不能超过365天');
      }
      this.filterParam.startTime = sTime;
      this.filterParam.endTime = eTime;
      this.fetchTableData();
    }
  }

  @Watch('timeRangeType')
  onTimeRangeTypeChange() {
    // 快捷按钮，计算时间范围
    if (this.timeRangeType !== null) {
      this.customTime = [];
      let startTime, endTime;
      switch (this.timeRangeType) {
        case 1:
          // 近7天
          startTime = moment()
            .startOf('d')
            .subtract(7, 'd');
          endTime = moment()
            .endOf('d')
            .subtract(1, 'd');
          break;
        case 2:
          // 近1月
          startTime = moment()
            .subtract(1, 'd')
            .startOf('d')
            .subtract(1, 'month');
          endTime = moment()
            .subtract(1, 'd')
            .endOf('d');
          break;
        default:
          startTime = moment().startOf('d');
          endTime = moment().endOf('d');
      }
      this.filterParam.startTime = startTime.format('YYYY-MM-DD HH:mm:ss');
      this.filterParam.endTime = endTime.format('YYYY-MM-DD HH:mm:ss');
      this.pageSize = 10;
      this.current = 1;
      this.fetchTableData();
    }
  }

  // 选择的车场
  selectParkIds: Array<string> = [];

  @Watch('selectParkIds')
  @Watch('filterParam.bizType')
  onParamChange(newValue: string) {
    if (newValue === '01') {
      this.isShowEtc = false;
    } else {
      this.isShowEtc = true;
    }
    this.pageSize = 10;
    this.current = 1;
    this.fetchTableData();
  }

  public filterParam: any = {
    startTime: '',
    endTime: '',
    bizType: '00'
  };
  current: number = 1;
  pageSize: number = 10;
  total: number = 0;
  tableData: any[] = [];
  tableLoading: boolean = false;
  chartData: any[] = [];
  options: EchartOption = new EchartOption();

  payMethodRatio: any = null;

  clear({ defaultParkIdList }) {
    this.filterParam.bizType = '00';
    this.timeRangeType = 1;
    this.customTime = [];
    this.selectParkIds = defaultParkIdList;
    this.$nextTick(() => {
      this.fetchTableData();
    });
  }

  // 初始化加载，确保机构树有值
  init() {
    this.onTimeRangeTypeChange();
    this.fetchTableData();
  }

  private created() {
    this.init();
  }
  /**
   * 点击搜索按钮
   */
  private search() {
    this.current = 1;
    this.fetchTableData();
  }
  private showSizeChangerChange(current: any, pageSize: any) {
    this.current = current;
    this.pageSize = pageSize;
    this.fetchTableData();
  }
  public async fetchTableData() {
    try {
      if (this.tableLoading) return;
      this.tableLoading = true;
      const param: any = {
        startDate: this.filterParam.startTime,
        endDate: this.filterParam.endTime,
        bizType: this.filterParam.bizType,
        currPage: this.current,
        pageSize: this.pageSize,
        parkIdList: this.selectParkIds
      };

      const res = await api.payMethodList(param);

      const data = res.data;
      if (data && data.responsePageDataSumVO && data.payMethodRatio) {
        const payMethodRatio = data.payMethodRatio;
        const { totalNum = 0, datas = [], total } = data.responsePageDataSumVO;
        this.total = Number(totalNum);
        this.tableData = datas;
        if (total) {
          console.log(' datas.length ', datas.length);
          datas.length > 0 &&
            this.tableData.push({
              isTotal: true,
              reportDay: '合计',
              eletricRate: total.totalEletricRate,
              wxpayAmount: total.totalWxAmount,
              alipayAmount: total.totalAlipayAmount,
              cashAmount: total.totalCashAmount,
              unionAmount: total.totalUnionAmount,
              otherAmount: total.totalOtherAmount,
              storeAmount: total.totalStoreCardAmount
            });
        }
        this.payMethodRatio = payMethodRatio;
      } else {
        this.tableData = [];
        this.total = 0;
        this.payMethodRatio = null;
      }
      await this.fetchChartData(param);
    } catch (error) {
      console.log(error);
      this.$message.error((error && error.msg) || '系统繁忙，请稍后再试');
    } finally {
      this.tableLoading = false;
    }
  }

  private async fetchChartData(param: any) {
    console.log('params-------------------', param);
    param.currPage = 0;
    param.pageSize = 0;
    // 图表查询不分页
    try {
      const res = await api.payMethodList(param);
      const data = res.data;
      if (data && data.responsePageDataSumVO && data.responsePageDataSumVO.datas) {
        const {
          responsePageDataSumVO: { datas = [] }
        } = data;
        this.chartData = datas;
      } else {
        this.chartData = [];
      }
    } catch (e) {
      console.log(e);
    } finally {
      this.refreshChart();
    }
  }

  private async download() {
    try {
      const param: any = {
        startDate: this.filterParam.startTime,
        endDate: this.filterParam.endTime,
        bizType: this.filterParam.bizType,
        currPage: this.current,
        pageSize: this.pageSize,
        parkIdList: this.selectParkIds
      };
      await api.payMethodExport(param);
    } catch (error) {
      console.log('error - ', error);
      this.$message.error((error && error.msg) || '系统繁忙，请稍后再试');
      console.log('exportLocalcashExport', '导出失败');
    }
  }

  private disabledDate(current: any) {
    return current && current >= moment().endOf('day');
  }

  getPopupContainer() {
    // @ts-ignore hack
    return this.$refs.panel['$el'];
  }
  get tableColums() {
    const tableColumArr = [
      {
        title: '序号',
        width: 80,
        customRender: (text: any, record: any, index: number) => {
          if (record.isTotal === true) {
            return '';
          }
          return `${(this.current - 1) * this.pageSize + index + 1}`;
        }
      },
      {
        title: '时间',
        dataIndex: 'reportDay'
      },
      {
        title: '电子支付率',
        dataIndex: 'eletricRate',
        customRender: (v: string) => {
          if (v === '') {
            return '--';
          } else {
            return this.numberRender(v, 2) + '%';
          }
        }
      },
      {
        dataIndex: 'wxpayAmount',
        customRender: this.numberRender,
        slots: { title: 'wxRatio' }
      },
      {
        dataIndex: 'alipayAmount',
        customRender: this.numberRender,
        slots: { title: 'alipayRatio' }
      },
      {
        dataIndex: 'cashAmount',
        customRender: this.numberRender,
        slots: { title: 'cashRatio' }
      },
      {
        dataIndex: 'unionAmount',
        customRender: this.numberRender,
        slots: { title: 'unionRatio' }
      },
      {
        dataIndex: 'storeAmount',
        customRender: this.numberRender,
        slots: { title: 'storeCardRatio' }
      },
      {
        dataIndex: 'otherAmount',
        customRender: this.numberRender,
        slots: { title: 'otherRatio' }
      }
    ];
    if (this.isShowEtc) {
      return tableColumArr;
    }
    return tableColumArr.filter(item => item.dataIndex !== 'storeAmount');
  }
  numberRender(value: any, num: any) {
    if (isNaN(value)) {
      return value;
    } else {
      const num = parseFloat(value).toFixed(2);
      return num.replace(/\d{1,3}(?=(\d{3})+(\.\d*)?$)/g, '$&,');
    }
  }

  titlePercentRender(value: number) {
    // const sum: any =
    //   this.payMethodRatio &&
    //   Object.values(this.payMethodRatio).reduce((x: any, y: any) => {
    //     return Number(x) + Number(y)
    //   })
    //   console.log('this.payMethodRatio',this.payMethodRatio)
    // console.log('sum', sum)
    // if (isNaN(value)) {
    //   return ''
    // } else {
    //   return parseFloat(((value / sum) * 100).toFixed(2)) + '%'
    // }
    if (isNaN(value)) {
      return '';
    } else {
      return parseFloat((value * 100).toFixed(2)) + '%';
    }
  }

  refreshChart() {
    let x = [];
    const y0 = [];
    const y1 = [];
    const y2 = [];
    const y3 = [];
    const y4 = [];
    const y5 = [];
    const seriesData = [];
    // 整理数据
    if (this.chartData.length) {
      x = _.union(this.chartData.map(i => i.reportDay).sort());
      for (const date of x) {
        for (const data of this.chartData) {
          if (data.reportDay === date) {
            y0.push(data.wxpayAmount);
            y1.push(data.alipayAmount);
            y2.push(data.cashAmount);
            y3.push(data.unionAmount);
            y4.push(data.otherAmount);
            this.filterParam.bizType == '00' && y5.push(data.storeAmount);
            break;
          }
        }
      }
    }
    const options: EchartOption = new EchartOption();
    options.setColor(['#52c41a', '#149896', '#8080ff', '#ff9800', '#FFC0CB', '#d77b86']);
    options.setLegend({
      show: true,
      bottom: 10
    });
    options.setGrid({
      left: '5%',
      right: '5%',
      containLabel: true
    });
    options.setXAxis(
      {
        type: 'category',
        boundaryGap: true,
        axisLabel: {
          color: '#000'
        },
        axisTick: {
          show: false
        },
        axisLine: {
          show: false
        },
        data: x
      },
      true
    );
    options.setYAxis(
      [
        {
          type: 'value',
          axisLabel: {
            show: true,
            color: '#000'
          },
          splitLine: {
            show: true,
            lineStyle: {
              color: '#ccc',
              type: 'dashed'
            }
          },
          axisTick: {
            show: false
          },
          axisLine: {
            show: false
          }
        }
      ],
      true
    );
    options.setTitle({
      show: true,
      text: '支付方式趋势分析' //主标题文本，'\n'指定换行
    });
    options.setSeries([
      {
        name: '微信',
        type: 'line',
        data: y0
      },
      {
        name: '支付宝',
        type: 'line',
        data: y1
      },
      {
        name: '现金',
        type: 'line',
        data: y2
      },
      {
        name: this.filterParam.bizType == '00' ? 'ETC' : '银行转账',
        type: 'line',
        data: y3
      },
      this.filterParam.bizType == '00' && {
        name: '储值卡',
        type: 'line',
        data: y5
      },
      {
        name: '其他',
        type: 'line',
        data: y4
      }
    ]);
    options.setTooltip({
      show: true,
      trigger: 'axis',
      axisPointer: {
        type: 'line'
      }
    });
    this.options = options;
  }
}
